import { ColorEnum } from '@/constants/color'
import SearchIcon from '@/features/ui/icons/components/SearchIcon'
import { FC } from 'react'
import { Pressable, StyleSheet } from 'react-native'

interface SearchButtonProps {
    onPress: () => void
}

const SearchButton: FC<SearchButtonProps> = ({ onPress }) => {
    return (
        <Pressable onPress={onPress} style={styles.button}>
            <SearchIcon fill={ColorEnum.BRICK_600} height={24} width={24} />
        </Pressable>
    )
}

const styles = StyleSheet.create({
    button: {
        position: 'absolute',
        right: 16,
        height: 24,
        width: 24,
        alignItems: 'center',
        justifyContent: 'center',
    },
})

export default SearchButton
